import algoliasearch from 'algoliasearch'

import * as ChannelTypes from 'remote/channels/types'
import { getChannelLabel } from 'data/channels/helpers'
import { selectors as ConfigSelectors } from 'data/config'
import { selectors as ChannelsSelectors } from 'data/channels'

export default async function searchNotes(
  storeState,
  query = '',
  { fetchSearchToken }
) {
  const searchApplicationId = ConfigSelectors.getSearchApplicationId(storeState)
  const searchToken = ConfigSelectors.getSearchToken(storeState)
  const client = algoliasearch(searchApplicationId, searchToken)
  const index = client.initIndex('notes')
  let hits = []
  try {
    hits = await new Promise((resolve, reject) =>
      index.search(
        {
          query,
          hitsPerPage: 20,
          // Keep attributes minimal for faster response time
          attributesToRetrieve: ['title', 'channelId'],
          attributesToHighlight: [],
          restrictSearchableAttributes: ['title'],
          filters: `isArchived:false`,
        },
        (err, content) => {
          if (err) {
            return reject(err)
          }
          return resolve(content.hits)
        }
      )
    )
  } catch (error) {
    fetchSearchToken()
    return []
  }

  return hits.reduce((memo, hit) => {
    const channel = ChannelsSelectors.getChannel(storeState, hit.channelId)
    const channelLabel = getChannelLabel(channel)
    const channelType = channel ? channel.type : ChannelTypes.PUBLIC
    return memo.concat({
      id: hit.objectID,
      channelLabel,
      channelType,
      ...hit,
    })
  }, [])
}
